export default __webpack_public_path__ + "static/media/school6.370083b5.webp";